
import React from 'react';
import { ModalFullPage } from '../../ModalFullPage';
import { AvailabilityCalendar, AvailabilityCalendarProps } from './AvailabilityCalendar.component';
import { useL10n } from '@uplift/hooks';
import { AvailabilitySettings } from '../AvailabilitySettings';
import { NavigationBackButton, ProviderDialogNavigation } from '../../Layout';


export type AvailabilityCalendarModalProps = AvailabilityCalendarProps & {
  open: boolean;
  onClose: () => void;
};


export const AvailabilityCalendarModal: React.FC<AvailabilityCalendarModalProps> = ({ open, onClose, ...props }) => {
  const l10n = useL10n();

  return (
    <ModalFullPage open={open} onClose={onClose} transition>
      <ProviderDialogNavigation
        title={l10n.calendar.availability.availabilityCalendar.title}
        titleTooltip={l10n.calendar.availability.availabilityCalendar.titleDetails}
        leftActions={(
          <NavigationBackButton onClick={onClose}>
            {l10n.calendar.availability.availabilityCalendar.backToSchedule}
          </NavigationBackButton>
        )}
        rightActions={
          <AvailabilitySettings color="light" />
        }
      />
      <AvailabilityCalendar {...props} />
    </ModalFullPage>
  );
};
